import { createContext, useState, useEffect } from "react";

// إنشاء السياق
export const AuthContext = createContext();

// المزوّد الرئيسي للتوثيق
export const AuthProvider = ({ children }) => {
  // الحالة: المستخدم أو التوكن
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem("token");
    console.log("📦 Initial token from localStorage:", token);
    return token || null;
  });

  // تحديث التوكن عند التحميل الأول (احتياطي)
  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("🔄 useEffect - localStorage token:", token);
    setUser(token);
  }, []);

  // تسجيل الدخول
  const login = (token) => {
    console.log("✅ Logging in with token:", token);
    localStorage.setItem("token", token);
    setUser(token);
  };

  // تسجيل الخروج
  const logout = () => {
    console.log("🚪 Logging out...");
    localStorage.removeItem("token");
    setUser(null);
  };

  // مشاركة السياق
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
